/* ============================================================
   LP — Product Configurator JS  |  lp-cfg.js
   Reads all product/pricing data from data-* attributes on
   the section wrapper element — no Liquid-injected JS vars.
   ============================================================ */

   (function () {
    'use strict';
  
    // ── Locate the section root ──────────────────────────────────
    // We scope everything to [data-lp-cfg-section] so multiple
    // instances on one page don't collide.
    var section = document.querySelector('[data-lp-cfg-section]');
    if (!section) return;
  
    // ── Read data attributes ─────────────────────────────────────
    var lpSinglePrice       = parseFloat(section.dataset.singlePrice  || '44.99');
    var lpBundlePrice       = parseFloat(section.dataset.bundlePrice  || '76.48');
    var lpChainPrice        = parseFloat(section.dataset.chainPrice   || '20.00');
    var lpNumberPlaceholder = section.dataset.numberPlaceholder || 'Select a Number (0–99)';
    var lpNumLabelBase      = section.dataset.numLabel   || 'Number Pendant';
    var lpMetalLabelBase    = section.dataset.metalLabel || 'Metal for Pendant';
  
    function lpParseJSON(key) {
      try {
        var v = section.dataset[key];
        if (!v) return null;
        // Check if the value looks like JSON before parsing
        v = v.trim();
        if (!v.startsWith('{') && !v.startsWith('[')) {
          console.warn('Invalid JSON for key ' + key + ': does not start with { or [');
          return null;
        }
        return JSON.parse(v);
      }
      catch (e) {
        console.warn('Error parsing JSON for key ' + key + ':', e.message);
        return null;
      }
    }
  
    var lpProductData    = lpParseJSON('product');
    var lpProductGold    = lpParseJSON('productGold');
    var lpProductSilver  = lpParseJSON('productSilver');
    var lpProductBlack   = lpParseJSON('productBlack');
    var lpChainDataGold      = lpParseJSON('chainProductGold');
    var lpChainDataSilver    = lpParseJSON('chainProductSilver');
    var lpChainDataBlack     = lpParseJSON('chainProductBlack');
    var lpEngraveProductData = lpParseJSON('productEngraving');
  
    // ── Pendant 2 separate products ──────────────────────────────
    var lpProductGold2   = lpParseJSON('productGold2');    // data-product-gold2
    var lpProductSilver2 = lpParseJSON('productSilver2');  // data-product-silver2
    var lpProductBlack2  = lpParseJSON('productBlack2');   // data-product-black2
    var lpChainDataGold2   = lpParseJSON('chainProductGold2');    // data-chain-product-gold2
    var lpChainDataSilver2 = lpParseJSON('chainProductSilver2');  // data-chain-product-silver2
    var lpChainDataBlack2  = lpParseJSON('chainProductBlack2');   // data-chain-product-black2
  
    function lpChainDataForMetal(metal) {
      var m = (metal || 'gold').toLowerCase();
      if (m === 'silver') return lpChainDataSilver;
      if (m === 'black') return lpChainDataBlack;
      return lpChainDataGold;
    }
  
    function lpChainDataForMetal2(metal) {
      var m = (metal || 'gold').toLowerCase();
      if (m === 'silver') return lpChainDataSilver2 || lpChainDataSilver;
      if (m === 'black')  return lpChainDataBlack2  || lpChainDataBlack;
      return lpChainDataGold2 || lpChainDataGold;
    }
  
    function lpProductForMetal(metal) {
      var m = (metal || 'gold').toLowerCase();
      if (m === 'silver') return lpProductSilver || lpProductData;
      if (m === 'black') return lpProductBlack || lpProductData;
      return lpProductGold || lpProductData;
    }
  
    // Pendant 2 uses its own product set; falls back to pendant 1 products if
    // the pendant-2 handles haven't been configured yet.
    function lpProductForMetal2(metal) {
      var m = (metal || 'gold').toLowerCase();
      if (m === 'silver') return lpProductSilver2 || lpProductGold2;
      if (m === 'black')  return lpProductBlack2  || lpProductGold2;
      return lpProductGold2;
    }
  
    function lpVariantByNumber(productData, numberStr) {
      if (!productData || !productData.variants || !productData.variants.length) return null;
      var v = productData.variants;
      for (var i = 0; i < v.length; i++) {
        var o1 = (v[i].option1 || '').toString().trim();
        var o2 = (v[i].option2 || '').toString().trim();
        var o3 = (v[i].option3 || '').toString().trim();
        if (o1 === numberStr || o2 === numberStr || o3 === numberStr) return v[i];
      }
      return v[0];
    }
  
    function getFirstAvailableVariant(productData) {
      if (!productData || !productData.variants || !productData.variants.length) return null;
      var v = productData.variants;
      for (var i = 0; i < v.length; i++) {
        if (v[i].available !== false) return v[i];
      }
      return v[0];
    }
  
    function variantPrice(variant) {
      if (!variant) return 0;
      var p = variant.price;
      if (p == null) return 0;
      return parseFloat(p) / 100;
    }
  
    function getUnassignedImages(productData) {
      if (!productData || !productData.images || !productData.images.length) return [];
      var variantImageIds = {};
      var variants = productData.variants || [];
      for (var i = 0; i < variants.length; i++) {
        var fim = variants[i].featured_image;
        if (fim && fim.id) variantImageIds[fim.id] = true;
      }
      return productData.images.filter(function (img) {
        return img && !variantImageIds[img.id];
      });
    }
  
    function lpRefreshThumbs() {
      var product = lpProductForMetal(lpMetal1);
      var images = getUnassignedImages(product);
      var container = qs('#lp-thumbs');
      if (!container) return;
      container.innerHTML = '';
      var maxThumbs = Math.min(images.length, 5);
      for (var i = 0; i < maxThumbs; i++) {
        var img = images[i];
        var srcFull = lpImageSrc(img) || (img.src || img.url);
        if (!srcFull) continue;
        var srcThumb = srcFull;
        if (typeof img.src === 'string' && img.src.indexOf('_') !== -1) {
          srcThumb = img.src.replace(/(_[0-9]+x[0-9]+)?(\.[a-z]+)$/i, '_200x200$2');
        }
        var div = document.createElement('div');
        div.className = 'lp-cfg__thumb' + (i === 0 ? ' lp-cfg__thumb--active' : '');
        div.onclick = (function (fullSrc) {
          return function () {
            lpSelectThumb(this, fullSrc);
          };
        })(srcFull);
        var thumbImg = document.createElement('img');
        thumbImg.src = srcThumb;
        thumbImg.alt = '';
        thumbImg.width = 100;
        thumbImg.height = 100;
        thumbImg.loading = 'lazy';
        div.appendChild(thumbImg);
        container.appendChild(div);
      }
    }
  
    function getAvailableNumbers(productData) {
      if (!productData || !productData.variants || !productData.variants.length) {
        return [];
      }
      var seen = {};
      var nums = [];
      var v = productData.variants;
      for (var i = 0; i < v.length; i++) {
        var o1 = (v[i].option1 || '').toString().trim();
        var o2 = (v[i].option2 || '').toString().trim();
        var o3 = (v[i].option3 || '').toString().trim();
        [o1, o2, o3].forEach(function (val) {
          if (val === '') return;
          var n = parseInt(val, 10);
          if (!isNaN(n) && n >= 0 && n <= 99 && !seen[n]) {
            seen[n] = true;
            nums.push(n);
          }
        });
      }
      nums.sort(function (a, b) { return a - b; });
      return nums.length ? nums : [0];
    }
  
    function lpRefreshNumberDropdown(pendantNum) {
      var product = pendantNum === 2 ? lpProductForMetal2(lpMetal2) : lpProductForMetal(lpMetal1);
      var numbers = getAvailableNumbers(product);
      var ddId = pendantNum === 2 ? 'lp-number-dropdown-2' : 'lp-number-dropdown';
      var labelId = pendantNum === 2 ? 'lp-number-label-2' : 'lp-number-label';
      var dd = qs('#' + ddId);
      if (!dd) return;
      var currentLabel = qs('#' + labelId);
      var currentVal = (currentLabel && currentLabel.textContent) ? currentLabel.textContent.trim() : '';
      dd.innerHTML = '';
      for (var i = 0; i < numbers.length; i++) {
        (function (num) {
          var div = document.createElement('div');
          var numStr = String(num);
          var variant = lpVariantByNumber(product, numStr);
          var available = variant && variant.available !== false;
          div.className = 'lp-cfg__number-opt' + (available ? '' : ' lp-cfg__number-opt--sold-out');
          div.textContent = num;
          if (available) {
            div.setAttribute('aria-disabled', 'false');
            div.onclick = function () { lpSelectNumber(this, ddId, labelId); };
          } else {
            div.setAttribute('aria-disabled', 'true');
          }
          dd.appendChild(div);
        })(numbers[i]);
      }
      var currentVariant = currentVal ? lpVariantByNumber(product, currentVal) : null;
      var currentAvailable = currentVariant && currentVariant.available !== false;
      var inList = numbers.some(function (n) { return String(n) === currentVal; });
      if ((!inList || !currentAvailable) && currentVal !== lpNumberPlaceholder) {
        if (currentLabel) currentLabel.textContent = lpNumberPlaceholder;
        if (pendantNum === 2) {
          lpCurrentVariantId2 = null;
          lpCurrentPrice2 = lpSinglePrice;
        } else {
          lpCurrentVariantId1 = null;
          lpCurrentPrice1 = lpSinglePrice;
        }
        lpUpdateCartBtn();
      }
    }
  
    // ── State ────────────────────────────────────────────────────
    var lpQtySelected   = 1;
    var lpEngraveOn     = false;
    var lpEngraveLocation = 'Front';
    var lpEngraveOn2    = false;
    var lpEngraveLocation2 = 'Front';
    var lpEngraveVariantUnder20  = 48340771504439;
    var lpEngraveVariant20OrMore = 50618814300471;
    var lpChainOn       = false;
    var lpChainVariantId  = null;
    var lpChainVariantId2 = null;
    var lpMetal1        = 'gold';
    var lpMetal2        = 'gold';
    var lpCurrentVariantId1 = null;
    var lpCurrentVariantId2 = null;
    var lpCurrentPrice1     = lpSinglePrice;
    var lpCurrentPrice2     = lpSinglePrice;
  
    // ── Helpers ──────────────────────────────────────────────────
    function qs(selector) { return section.querySelector(selector); }
    function qsa(selector) { return section.querySelectorAll(selector); }
  
    // Format a dollar-amount float using the money format baked into the section
    // element at Liquid render time. We intentionally bypass window.Shopify.formatMoney
    // so that third-party currency apps cannot intercept and re-convert these values.
    var _lpMoneyFormat = (section.dataset.moneyFormat || '${{amount}}').replace(/&amp;/g, '&');
    function lpMoney(dollars) {
      var amount      = dollars.toFixed(2);
      var amountNoDec = String(Math.round(dollars));
      var amountWithComma = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return _lpMoneyFormat
        .replace('{{amount_no_decimals_with_comma_separator}}', amountNoDec.replace(/\B(?=(\d{3})+(?!\d))/g, ','))
        .replace('{{amount_with_comma_separator}}', amountWithComma)
        .replace('{{amount_no_decimals}}', amountNoDec)
        .replace('{{amount}}', amount);
    }
  
    function lpImageSrc(img) {
      if (!img) return '';
      return img.src || img.url || (typeof img === 'string' ? img : '');
    }
  
    // ── lpSwitchTab ──────────────────────────────────────────────
    window.lpSwitchTab = function (n) {
      var t1 = qs('#lp-tab1');
      var t2 = qs('#lp-tab2');
      var c1 = qs('#lp-tab1-content');
      var c2 = qs('#lp-tab2-content');
      if (!t1 || !t2 || !c1 || !c2) return;
  
      t1.classList.toggle('lp-cfg__tab--active', n === 1);
      t2.classList.toggle('lp-cfg__tab--active', n === 2);
      c1.style.display = n === 1 ? 'grid' : 'none';
      c2.style.display = n === 2 ? 'block' : 'none';
    };
  
    // ── lpSelectThumb ────────────────────────────────────────────
    window.lpSelectThumb = function (el, src) {
      qsa('.lp-cfg__thumb').forEach(function (t) {
        t.classList.remove('lp-cfg__thumb--active');
      });
      el.classList.add('lp-cfg__thumb--active');
      var mainImg = qs('#lp-main-img');
      if (mainImg) mainImg.src = src;
    };
  
    // ── lpSelectQty ──────────────────────────────────────────────
    window.lpSelectQty = function (n) {
      lpQtySelected = n;
      var q1   = qs('#lp-qty1');
      var q2   = qs('#lp-qty2');
      var sel2 = qs('#lp-number-selector-2');
      var nl1  = qs('#lp-num-label-1');
      var ml1  = qs('#lp-metal-label-1');
      var wrap = qs('#lp-selectors-wrap');
      var qtyParent = q1 && q1.parentNode;
  
      if (q1) q1.classList.toggle('lp-cfg__qty-option--selected', n === 1);
      if (q2) q2.classList.toggle('lp-cfg__qty-best--active', n === 2);
      if (sel2) sel2.style.display = n === 2 ? 'block' : 'none';
      if (wrap) wrap.classList.toggle('lp-cfg__selectors-wrap--two', n === 2);
  
      // Place selectors-wrap directly under the selected option (like in the reference images)
      if (wrap && qtyParent) {
        if (n === 1) {
          qtyParent.insertBefore(wrap, q2);
        } else {
          qtyParent.appendChild(wrap);
        }
      }
  
      // When 2 pendants: show only one engraving and one chain (Number Pendant only), not for Mini Necklace
      var engrave2Section = qs('#lp-engrave-pendant2-section');
      if (engrave2Section) engrave2Section.style.display = 'none';

      // Update Pendant 1 engraving label to show "(Number Pendant)" when 2 pendants selected
      var engraveTitle1 = qs('#lp-engrave-title-1');
      if (engraveTitle1) {
        if (!engraveTitle1.dataset.originalText) {
          engraveTitle1.dataset.originalText = engraveTitle1.textContent.trim();
        }
        engraveTitle1.textContent = n === 2
          ? engraveTitle1.dataset.originalText + ' (Number Pendant)'
          : engraveTitle1.dataset.originalText;
      }

      // Update chain title: show original text with "(Number Pendant)" when 2 pendants selected
      var chainTitleEl = qs('#lp-chain-title');
      if (chainTitleEl) {
        if (!chainTitleEl.dataset.originalText) {
          chainTitleEl.dataset.originalText = chainTitleEl.textContent.trim();
        }
        chainTitleEl.textContent = n === 2
          ? chainTitleEl.dataset.originalText + ' (Number Pendant)'
          : chainTitleEl.dataset.originalText;
      }

      if (n === 2) lpRefreshNumberDropdown(2);
      lpRefreshChainVariantSelector();
      lpUpdateCartBtn();
    };
  
    // ── lpSelectMetalOption (metal swatches: gold / silver / black) ─
    window.lpSelectMetalOption = function (el, pendantNum) {
      var wrap = el.closest('.lp-cfg__metal-swatches');
      if (wrap) {
        wrap.querySelectorAll('.lp-cfg__metal-swatch').forEach(function (btn) {
          btn.classList.remove('lp-cfg__metal-swatch--selected');
          btn.setAttribute('aria-pressed', 'false');
        });
      }
      el.classList.add('lp-cfg__metal-swatch--selected');
      el.setAttribute('aria-pressed', 'true');
      var metal = (el.dataset.metal || 'gold').toLowerCase();
      var numLabel = qs(pendantNum === 2 ? '#lp-number-label-2' : '#lp-number-label');
      var numberStr = (numLabel && numLabel.textContent) ? numLabel.textContent.trim() : '';
      if (numberStr === lpNumberPlaceholder) numberStr = '';
  
      if (pendantNum === 2) {
        lpMetal2 = metal;
        var prod2 = lpProductForMetal2(metal);
        var v2 = numberStr ? lpVariantByNumber(prod2, numberStr) : null;
        lpCurrentVariantId2 = v2 ? v2.id : null;
        lpCurrentPrice2 = v2 ? (parseFloat(v2.price) / 100) : lpSinglePrice;
      } else {
        lpMetal1 = metal;
        var prod1 = lpProductForMetal(metal);
        var v1 = numberStr ? lpVariantByNumber(prod1, numberStr) : null;
        lpCurrentVariantId1 = v1 ? v1.id : null;
        lpCurrentPrice1 = v1 ? (parseFloat(v1.price) / 100) : lpSinglePrice;
        var mainImg = qs('#lp-main-img');
        if (mainImg) {
          var src = (v1 && v1.featured_image) ? lpImageSrc(v1.featured_image) : (prod1 && prod1.featured_image) ? lpImageSrc(prod1.featured_image) : '';
          if (src) mainImg.src = src;
        }
        lpRefreshThumbs();
      }
      lpRefreshNumberDropdown(pendantNum);
      lpRefreshChainVariantSelector();
      lpUpdateCartBtn();
    };
  
    window.lpSelectMetal = function () { /* kept for compat; metal now via lpSelectMetalOption */ };
  
    // ── lpToggleDropdown (expand below trigger) ───────────────────
    window.lpToggleDropdown = function (ddId, arrowId) {
      var dd    = qs('#' + ddId);
      var arrow = qs('#' + arrowId);
      if (!dd) return;
      qsa('.lp-cfg__dropdown--open').forEach(function (d) {
        if (d !== dd) d.classList.remove('lp-cfg__dropdown--open');
      });
      qsa('.lp-cfg__select-arrow--open').forEach(function (a) {
        if (a !== arrow) a.classList.remove('lp-cfg__select-arrow--open');
      });
      var isOpen = dd.classList.toggle('lp-cfg__dropdown--open');
      if (arrow) arrow.classList.toggle('lp-cfg__select-arrow--open', isOpen);
    };
  
    // ── lpSelectNumber ───────────────────────────────────────────
    window.lpSelectNumber = function (el, ddId, labelId) {
      if (el.classList.contains('lp-cfg__number-opt--sold-out')) return;
      var dd = qs('#' + ddId);
      if (dd) {
        dd.querySelectorAll('.lp-cfg__number-opt').forEach(function (o) {
          o.classList.remove('lp-cfg__number-opt--selected');
        });
        dd.classList.remove('lp-cfg__dropdown--open');
      }
      el.classList.add('lp-cfg__number-opt--selected');
  
      var label = qs('#' + labelId);
      var numberStr = el.textContent.trim();
      if (label) label.textContent = numberStr;
  
      var arrowId = ddId.replace('dropdown', 'arrow');
      var arrow   = qs('#' + arrowId);
      if (arrow) arrow.classList.remove('lp-cfg__select-arrow--open');
  
      var pendantNum = (ddId.indexOf('-2') !== -1) ? 2 : 1;
      var metal = pendantNum === 2 ? lpMetal2 : lpMetal1;
      var prod = pendantNum === 2 ? lpProductForMetal2(metal) : lpProductForMetal(metal);
      var v = lpVariantByNumber(prod, numberStr);
      if (pendantNum === 2) {
        lpCurrentVariantId2 = v ? v.id : null;
        lpCurrentPrice2 = v ? (parseFloat(v.price) / 100) : lpSinglePrice;
      } else {
        lpCurrentVariantId1 = v ? v.id : null;
        lpCurrentPrice1 = v ? (parseFloat(v.price) / 100) : lpSinglePrice;
        var mainImg = qs('#lp-main-img');
        if (mainImg) {
          var src = (v && v.featured_image) ? lpImageSrc(v.featured_image) : (prod && prod.featured_image) ? lpImageSrc(prod.featured_image) : '';
          if (src) mainImg.src = src;
        }
      }
      lpUpdateCartBtn();
    };
  
    // ── lpToggleEngraving ────────────────────────────────────────
    window.lpToggleEngraving = function (pendantNum) {
      pendantNum = pendantNum || 1;
      var isOn, cbId, optsId, wrapId;
      if (pendantNum === 2) {
        lpEngraveOn2 = !lpEngraveOn2;
        isOn = lpEngraveOn2;
        cbId = '#lp-engrave-checkbox-2';
        optsId = '#lp-engrave-options-2';
        wrapId = '#lp-engrave-wrap-2';
      } else {
        lpEngraveOn = !lpEngraveOn;
        isOn = lpEngraveOn;
        cbId = '#lp-engrave-checkbox';
        optsId = '#lp-engrave-options';
        wrapId = '#lp-engrave-wrap';
      }
      var cb   = qs(cbId);
      var opts = qs(optsId);
      var wrap = qs(wrapId);
      if (cb) {
        cb.textContent = isOn ? '✓' : '';
        cb.style.background = isOn ? '#0a0a0a' : '#fff';
        cb.classList.toggle('lp-cfg__engrave-checkbox--unchecked', !isOn);
      }
      if (wrap) wrap.classList.toggle('lp-cfg__engrave--selected', isOn);
      if (opts) opts.classList.toggle('lp-cfg__engrave-input--visible', isOn);
      lpUpdateCartBtn();
    };
  
    // ── lpSetEngraveOption (Location only; show one or two text inputs for Both) ─
    window.lpSetEngraveOption = function (type, value, pendantNum) {
      if (type !== 'location') return;
      pendantNum = pendantNum || 1;
      var suffix = pendantNum === 2 ? '-2' : '';
      if (pendantNum === 2) {
        lpEngraveLocation2 = value;
      } else {
        lpEngraveLocation = value;
      }
      // Update only the location buttons belonging to this pendant
      qsa('.lp-cfg__engrave-btn[data-value]').forEach(function (btn) {
        if (!btn.id || btn.id.indexOf('lp-engrave-loc') === -1) return;
        var isP2Btn = btn.id.slice(-2) === '-2';
        if ((pendantNum === 2) !== isP2Btn) return;
        btn.classList.toggle('lp-cfg__engrave-btn--selected', btn.getAttribute('data-value') === value);
      });
      var rowSingle = qs('#lp-engrave-row-single' + suffix);
      var rowBoth   = qs('#lp-engrave-row-both' + suffix);
      var labelEl   = qs('#lp-engrave-text-label' + suffix);
      if (value === 'Both') {
        if (rowSingle) rowSingle.style.display = 'none';
        if (rowBoth) rowBoth.style.display = 'flex';
      } else {
        if (rowSingle) rowSingle.style.display = 'flex';
        if (rowBoth) rowBoth.style.display = 'none';
        if (labelEl) labelEl.textContent = value === 'Front' ? 'Front' : value === 'Back' ? 'Back' : 'ENGRAVING TEXT';
      }
      lpUpdateCartBtn();
    };
  
    // ── lpToggleChain ────────────────────────────────────────────
    window.lpToggleChain = function () {
      lpChainOn = !lpChainOn;
      var cb = qs('#lp-chain-checkbox');
      if (cb) {
        cb.classList.toggle('lp-cfg__chain-checkbox--checked', lpChainOn);
        cb.textContent = lpChainOn ? '✓' : '';
      }
      lpRefreshChainVariantSelector();
      lpUpdateCartBtn();
    };
  
    // ── Chain variant selector(s): chain from selected product metafield (5mm), 1 or 2 pendants ─
    function lpRefreshChainVariantSelector() {
      var wrap1 = qs('#lp-chain-variants');
      var wrap2 = qs('#lp-chain-variants-2');
      var sel1  = qs('#lp-chain-variant');
      var sel2  = qs('#lp-chain-variant-2');
      if (!wrap1 || !sel1) return;
  
      if (!lpChainOn) {
        wrap1.classList.remove('lp-cfg__chain-variants--visible');
        sel1.style.display = 'none';
        if (wrap2) wrap2.classList.remove('lp-cfg__chain-variants--visible');
        if (sel2) sel2.style.display = 'none';
        lpChainVariantId = null;
        lpChainVariantId2 = null;
        return;
      }
  
      // Chain upgrade uses Number Pendant (Pendant 1) product's custom.chain_product metafield only
      var chainData1 = lpChainDataForMetal(lpMetal1);
      var chainData2 = null; // When 2 pendants we show only one chain (Number Pendant), not for Mini Necklace
  
      lpUpdateChainPriceDisplay();
  
      function fillChainSelect(data, sel, setVariantId) {
        if (!sel) return;
        if (!data || !data.variants || data.variants.length === 0) {
          setVariantId(null);
          sel.style.display = 'none';
          sel.innerHTML = '';
          return;
        }
        var variants = data.variants;
        var firstAvailable = null;
        for (var i = 0; i < variants.length; i++) {
          if (variants[i].available !== false) {
            firstAvailable = variants[i];
            break;
          }
        }
        if (variants.length === 1) {
          setVariantId(firstAvailable ? firstAvailable.id : variants[0].id);
          sel.style.display = 'block';
          sel.innerHTML = '';
          var opt = document.createElement('option');
          opt.value = variants[0].id;
          opt.textContent = (variants[0].title && variants[0].title !== 'Default Title' ? variants[0].title : (variants[0].option1 || 'Chain Option')) + (variants[0].available === false ? ' (Sold out)' : '');
          opt.disabled = variants[0].available === false;
          sel.appendChild(opt);
          sel.value = String(variants[0].id);
          sel.onchange = function () {
            setVariantId(parseInt(sel.value, 10) || null);
            lpUpdateCartBtn();
          };
          return;
        }
        sel.style.display = 'block';
        sel.innerHTML = '';
        
        // Filter for Width = 5mm variants (option2 or option3 contains '5mm')
        var filteredVariants = [];
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i];
          var opt2 = v.option2 || '';
          var opt3 = v.option3 || '';
          if (opt2.indexOf('5mm') !== -1 || opt3.indexOf('5mm') !== -1) {
            filteredVariants.push(v);
          }
        }
        
        // If no 5mm variants found, use all variants as fallback
        if (filteredVariants.length === 0) {
          filteredVariants = variants;
        }
        
        // Extract unique Length values (option1) from filtered variants
        var lengthValues = [];
        var lengthMap = {};
        for (var i = 0; i < filteredVariants.length; i++) {
          var v = filteredVariants[i];
          var lengthVal = v.option1 || '';
          if (lengthVal && !lengthMap[lengthVal]) {
            lengthMap[lengthVal] = v;
            lengthValues.push({ label: lengthVal, variant: v });
          }
        }
        
        lengthValues.forEach(function (item) {
          var v = item.variant;
          var opt = document.createElement('option');
          opt.value = v.id;
          opt.textContent = item.label + (v.available === false ? ' (Sold out)' : '');
          opt.disabled = v.available === false;
          sel.appendChild(opt);
        });
        // Set default to first length option
        if (lengthValues.length > 0) {
          var defaultId = lengthValues[0].variant.id;
          setVariantId(defaultId);
          sel.value = String(defaultId);
        }
      }
  
      var variants1 = chainData1 && chainData1.variants ? chainData1.variants : [];
      if (variants1.length > 0) {
        wrap1.style.display = 'block';
        wrap1.classList.add('lp-cfg__chain-variants--visible');
        fillChainSelect(chainData1, sel1, function (id) { lpChainVariantId = id; });
        sel1.onchange = function () {
          lpChainVariantId = parseInt(sel1.value, 10) || null;
          lpUpdateCartBtn();
        };
      } else {
        wrap1.style.display = 'none';
        wrap1.classList.remove('lp-cfg__chain-variants--visible');
        lpChainVariantId = null;
      }
  
      // When 2 pendants: only one chain upgrade (Number Pendant) — hide second chain selector
      if (wrap2) {
        wrap2.style.display = 'none';
        wrap2.classList.remove('lp-cfg__chain-variants--visible');
      }
      if (sel2) sel2.style.display = 'none';
      lpChainVariantId2 = null;
    }
  
    // ── lpUpdateChainPriceDisplay ────────────────────────────────
    // Shows pendant 1's chain price (per-chain label beside the toggle).
    // Shows hardcoded $59.99 as compare-at price with current sale price.
    function lpUpdateChainPriceDisplay() {
      var el = qs('#lp-chain-price-display');
      if (!el) return;
      
      try {
        var price = lpGetChainPrice(lpMetal1);
        if (price === null || price === undefined) price = lpChainPrice;
        
        var priceStr = price === 0 ? 'FREE' : lpMoney(price);
        var comparePrice = 59.99; // Hardcoded compare-at price
        
        // Show strikethrough compare price if current price is less
        if (comparePrice > price) {
          el.innerHTML = '<span style="text-decoration: line-through; color: #888888;">' + lpMoney(comparePrice) + '</span> ' + priceStr;
        } else {
          el.textContent = priceStr;
        }
      } catch (e) {
        // Fallback: just show the default price
        el.textContent = lpMoney(lpChainPrice);
      }
    }
  
    // ── lpGetEngraveVariant ───────────────────────────────────────
    // Mirrors the PDP logic from product-template-new.liquid:
    //   Front / Back  → engraving_product.variants[1]  (One Side)
    //   Both          → engraving_product.variants[2]  (Both Sides — separate variant)
    // Falls back to the hardcoded variant IDs when product data is not loaded.
    function lpGetEngraveVariant(location) {
      if (lpEngraveProductData && lpEngraveProductData.variants && lpEngraveProductData.variants.length >= 2) {
        return location === 'Both'
          ? (lpEngraveProductData.variants[2] || lpEngraveProductData.variants[1])
          : lpEngraveProductData.variants[1];
      }
      // Fallback: use the hardcoded variant IDs (lpEngraveVariantUnder20 = single side,
      // lpEngraveVariant20OrMore = both sides — kept for backward compatibility)
      return { id: location === 'Both' ? lpEngraveVariant20OrMore : lpEngraveVariantUnder20, price: 0 };
    }
  
    // ── lpGetEngravePrice ─────────────────────────────────────────
    // Returns the engraving cost in dollars for the given location.
    // Both Sides uses its own variant with its own price — no multiplication needed.
    function lpGetEngravePrice(location) {
      var v = lpGetEngraveVariant(location);
      return v ? parseFloat(v.price) / 100 : 0;
    }
  
    // ── lpGetChainPrice ───────────────────────────────────────────
    // Returns the chain price in dollars for the given metal.
    function lpGetChainPrice(metal) {
      var data = lpChainDataForMetal(metal);
      if (!data || !data.variants || !data.variants.length) return lpChainPrice;
      var variants = data.variants;
      
      // Filter for 5mm width variants (option2 or option3 contains '5mm')
      var filteredVariants = [];
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var opt2 = v.option2 || '';
        var opt3 = v.option3 || '';
        if (opt2.indexOf('5mm') !== -1 || opt3.indexOf('5mm') !== -1) {
          filteredVariants.push(v);
        }
      }
      
      // If no 5mm variants found, use all variants as fallback
      if (filteredVariants.length === 0) {
        filteredVariants = variants;
      }
      
      // Return first available variant price, or first variant if none available
      for (var i = 0; i < filteredVariants.length; i++) {
        if (filteredVariants[i].available !== false) return parseFloat(filteredVariants[i].price) / 100;
      }
      return parseFloat(filteredVariants[0].price) / 100;
    }
  
    // ── lpUpdateEngravePriceDisplay ──────────────────────────────
    // Only updates the display when product data is loaded; otherwise the
    // Liquid-rendered engrave_price_label value is left as-is.
    // Shows compare at price (strikethrough) if available.
    function lpUpdateEngravePriceDisplay() {
      if (!lpEngraveProductData || !lpEngraveProductData.variants || !lpEngraveProductData.variants.length) {
        return;
      }
  
      function formatEngravePrice(variant) {
        if (!variant) return '';
        var price = parseFloat(variant.price) / 100;
        var comparePrice = variant.compare_at_price ? parseFloat(variant.compare_at_price) / 100 : null;
        
        var priceStr = price === 0 ? 'FREE' : lpMoney(price);
        
        // If compare at price exists and is higher than regular price, show strikethrough
        if (comparePrice && comparePrice > price) {
          return '<span style="text-decoration: line-through; color: #888888;">' + lpMoney(comparePrice) + '</span> ' + priceStr;
        }
        
        return priceStr;
      }
  
      var el1 = qs('#lp-engrave-price');
      if (el1) {
        var v1 = lpGetEngraveVariant(lpEngraveLocation);
        el1.innerHTML = formatEngravePrice(v1);
      }
      var el2 = qs('#lp-engrave-price-2');
      if (el2) {
        var v2 = lpGetEngraveVariant(lpEngraveLocation2);
        el2.innerHTML = formatEngravePrice(v2);
      }
    }
  
    // ── lpUpdateCartBtn ──────────────────────────────────────────
    window.lpUpdateCartBtn = function () {
      var subtotal;
      if (lpQtySelected === 2) {
        subtotal = (lpCurrentPrice1 + lpCurrentPrice2) * 0.85; // 15% bundle discount
      } else {
        subtotal = lpCurrentPrice1;
      }
  
      // Chain: one chain only (Number Pendant's custom.chain_product), including when 2 pendants
      if (lpChainOn) subtotal += lpGetChainPrice(lpMetal1);

      // Engraving: one engraving only (Number Pendant), including when 2 pendants
      if (lpEngraveOn) subtotal += lpGetEngravePrice(lpEngraveLocation);
  
      var btn = qs('#lp-atc-btn');
      if (btn) btn.textContent = 'Add to Cart — ' + lpMoney(subtotal);
  
      var bundlePrice = (lpCurrentPrice1 + lpCurrentPrice2) * 0.85;
      var singlePrice = lpCurrentPrice1;
  
      var displayPrice = qs('#lp-display-price');
      if (displayPrice) {
        displayPrice.textContent = lpMoney(lpQtySelected === 2 ? bundlePrice : singlePrice);
      }
  
      var qtySinglePrice = qs('#lp-qty-single-price');
      if (qtySinglePrice) qtySinglePrice.textContent = lpMoney(singlePrice);
  
      var qtyBundlePrice = qs('#lp-qty-bundle-price');
      if (qtyBundlePrice) qtyBundlePrice.textContent = lpMoney(bundlePrice);
  
      var tabPrice = qs('#lp-tab-price');
      if (tabPrice) {
        tabPrice.textContent = lpMoney(lpQtySelected === 2 ? bundlePrice : singlePrice);
      }
  
      lpUpdateEngravePriceDisplay();
    };
  
    // ── Error handling functions ──────────────────────────────────
    function lpClearErrors() {
      // Clear engraving errors
      var engraveError1 = qs('#lp-engrave-error-1');
      if (engraveError1) {
        engraveError1.textContent = '';
        engraveError1.classList.remove('lp-cfg__error-message--visible');
      }
      var engraveError2 = qs('#lp-engrave-error-2');
      if (engraveError2) {
        engraveError2.textContent = '';
        engraveError2.classList.remove('lp-cfg__error-message--visible');
      }
      // Clear number errors
      var numberError1 = qs('#lp-number-error-1');
      if (numberError1) {
        numberError1.textContent = '';
        numberError1.classList.remove('lp-cfg__error-message--visible');
      }
      var numberError2 = qs('#lp-number-error-2');
      if (numberError2) {
        numberError2.textContent = '';
        numberError2.classList.remove('lp-cfg__error-message--visible');
      }
      // Remove highlight classes
      var inputs = document.querySelectorAll('.lp-cfg__engrave-text-input, .lp-cfg__select-trigger');
      inputs.forEach(function(inp) {
        inp.classList.remove('lp-error');
      });
    }
  
    function lpHideError(elementId, highlightSelectors) {
      var errorEl = qs('#' + elementId);
      if (errorEl) {
        errorEl.textContent = '';
        errorEl.classList.remove('lp-cfg__error-message--visible');
      }
      if (highlightSelectors) {
        var selectors = highlightSelectors.split(',');
        selectors.forEach(function(sel) {
          var highlightEls = document.querySelectorAll(sel.trim());
          highlightEls.forEach(function(el) {
            el.classList.remove('lp-error');
          });
        });
      }
    }
  
    function lpShowError(elementId, message, highlightSelectors) {
      var errorEl = qs('#' + elementId);
      if (errorEl) {
        errorEl.textContent = message;
        errorEl.classList.add('lp-cfg__error-message--visible');
        errorEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      if (highlightSelectors) {
        var selectors = highlightSelectors.split(',');
        selectors.forEach(function(sel) {
          var highlightEls = document.querySelectorAll(sel.trim());
          highlightEls.forEach(function(el) {
            el.classList.add('lp-error');
          });
        });
      }
      // Auto-hide after 8 seconds
      setTimeout(function() {
        lpHideError(elementId, highlightSelectors);
      }, 8000);
    }
  
    // ── lpAddToCart ──────────────────────────────────────────────
  
    window.lpAddToCart = function () {
      lpClearErrors();
      // Engraving text by location (single input or Front + Back when Both)
      var frontText = '';
      var backText = '';
      if (lpEngraveOn) {
        if (lpEngraveLocation === 'Both') {
          var frontInp = qs('#lp-engrave-text-front');
          var backInp = qs('#lp-engrave-text-back');
          frontText = frontInp ? frontInp.value.trim() : '';
          backText = backInp ? backInp.value.trim() : '';
        } else {
          var singleInp = qs('#lp-engrave-text');
          var singleVal = singleInp ? singleInp.value.trim() : '';
          if (lpEngraveLocation === 'Front') frontText = singleVal;
          else if (lpEngraveLocation === 'Back') backText = singleVal;
        }
      }
  
      // ── Pendant 1 ─────────────────────────────────────────────
      var number1Label = qs('#lp-number-label');
      var number1      = number1Label ? number1Label.textContent.trim() : '';
  
      if (!number1 || number1 === lpNumberPlaceholder) {
        lpShowError('lp-number-error-1', 'Please select a number.', '#lp-number-selector-1 .lp-cfg__select-trigger');
        return;
      }
  
      var prod1 = lpProductForMetal(lpMetal1);
      var v1 = lpVariantByNumber(prod1, number1);
      var variantId1 = (v1 && v1.id) ? v1.id : (lpCurrentVariantId1 || (prod1 && prod1.variants && prod1.variants[0] ? prod1.variants[0].id : null));
  
      if (!variantId1) {
        lpShowError('lp-number-error-1', 'Please select options for Pendant 1.', '#lp-number-selector-1 .lp-cfg__select-trigger');
        return;
      }
  
      // ── Validate engraving text ────────────────────────────────
      if (lpEngraveOn) {
        if (lpEngraveLocation === 'Both' && (!frontText || !backText)) {
          lpShowError('lp-engrave-error-1', 'Please enter engraving text for both Front and Back.', '#lp-engrave-text-front, #lp-engrave-text-back');
          return;
        }
        if (lpEngraveLocation !== 'Both' && !frontText && !backText) {
          lpShowError('lp-engrave-error-1', 'Please enter your engraving text.', '#lp-engrave-text');
          return;
        }
      }
  
      // When chain is selected, get length for pendant product property (chain length / 5mm Cuban)
      var chainLengthForPendant = '';
      if (lpChainOn && lpChainVariantId) {
        var chainDataForLength = lpChainDataForMetal(lpMetal1);
        if (chainDataForLength && chainDataForLength.variants) {
          for (var cli = 0; cli < chainDataForLength.variants.length; cli++) {
            if (chainDataForLength.variants[cli].id === lpChainVariantId) {
              chainLengthForPendant = (chainDataForLength.variants[cli].option1 || '').trim();
              break;
            }
          }
        }
        if (!chainLengthForPendant) {
          var chainSelForLength = qs('#lp-chain-variant');
          if (chainSelForLength && chainSelForLength.options[chainSelForLength.selectedIndex]) {
            chainLengthForPendant = chainSelForLength.options[chainSelForLength.selectedIndex].text.replace(/\s*\(Sold out\)\s*$/i, '').trim();
          }
        }
      }

      var props1 = {};
      if (lpQtySelected === 2) props1['Pendant'] = 'Pendant 1';
      if (lpChainOn && chainLengthForPendant) props1['Chain'] = chainLengthForPendant + ' / 5mm Cuban';
      else if (lpChainOn) props1['Chain'] = '5mm Cuban';

      var items = [{ id: variantId1, quantity: 1, properties: props1 }];
  
      // ── Pendant 2 (qty=2 only) ─────────────────────────────────
      // When 2 pendants: only one engraving (Number Pendant) — no Pendant 2 engraving validation
      if (lpQtySelected === 2) {
        var number2Label = qs('#lp-number-label-2');
        var number2      = number2Label ? number2Label.textContent.trim() : '';
  
        if (!number2 || number2 === lpNumberPlaceholder) {
          lpShowError('lp-number-error-2', 'Please select a number.', '#lp-number-selector-2 .lp-cfg__select-trigger');
          return;
        }
  
        var prod2 = lpProductForMetal2(lpMetal2);
        var v2 = lpVariantByNumber(prod2, number2);
        var variantId2 = (v2 && v2.id) ? v2.id : (lpCurrentVariantId2 || (prod2 && prod2.variants && prod2.variants[0] ? prod2.variants[0].id : null));
  
        if (!variantId2) {
          lpShowError('lp-number-error-2', 'Please select options for Pendant 2.', '#lp-number-selector-2 .lp-cfg__select-trigger');
          return;
        }
  
        var props2 = { 'Pendant': 'Pendant 2' };
        // When 2 pendants only one chain (Number Pendant) — Mini Necklace has no chain upgrade
        items.push({ id: variantId2, quantity: 1, properties: props2 });
      }
  
      // ── Engraving product(s): variant by pendant price (< 20 vs >= 20), with line item properties ─
      if (lpEngraveOn && (frontText || backText)) {
        var engProps = { 'Location': lpEngraveLocation };
        if (lpQtySelected === 2) engProps['For Pendant'] = '1';
        if (frontText) engProps['Front'] = frontText;
        if (backText) engProps['Back'] = backText;
        var engV1 = lpGetEngraveVariant(lpEngraveLocation);
        var engVariantId = engV1 ? engV1.id : (lpEngraveLocation === 'Both' ? lpEngraveVariant20OrMore : lpEngraveVariantUnder20);
  items.push({ id: engVariantId, quantity: 1, properties: engProps });
      }
  
      // ── Engraving for Pendant 2 ───────────────────────────────
      // When 2 pendants: only one engraving (Number Pendant) — do not add Pendant 2 / Mini Necklace engraving
      // (Pendant 2 engraving section is hidden in UI when 2 pendants selected)

      // ── Chain upgrade: one chain only, from Number Pendant's custom.chain_product metafield ─
      // Chain line item: Pendant Number only (chain length / 5mm Cuban is on the pendant product)
      if (lpChainOn && lpChainVariantId) {
        var chainProps1 = { 'Pendant Number': number1 };
        if (lpQtySelected === 2) chainProps1['Pendant'] = 'Pendant 1';
        items.push({ id: lpChainVariantId, quantity: 1, properties: chainProps1 });
      }
  
      var atcBtn = qs('#lp-atc-btn');
      var btnText = atcBtn ? atcBtn.textContent : 'Add to Cart';
      if (atcBtn) {
        atcBtn.disabled = true;
        atcBtn.classList.add('lp-cfg__atc-btn--loading');
        atcBtn.textContent = 'Adding…';
      }
  
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (atcBtn) {
          atcBtn.disabled = false;
          atcBtn.classList.remove('lp-cfg__atc-btn--loading');
          atcBtn.textContent = btnText;
        }
        if (data.status && data.status !== 200 && data.message) {
          alert(data.message);
          return;
        }
        lpOpenCartDrawer();
      })
      .catch(function (err) {
        if (atcBtn) {
          atcBtn.disabled = false;
          atcBtn.classList.remove('lp-cfg__atc-btn--loading');
          atcBtn.textContent = btnText;
        }
      });
    };
  
    function lpRefreshCartDrawerContent() {
      var sectionId = 'cart-drawer';
      return fetch(window.location.pathname + '?sections=' + sectionId)
        .then(function (res) { return res.ok ? res.json() : null; })
        .then(function (data) {
          if (!data) return;
          var html = data[sectionId] || data['cart-drawer'];
          if (!html || typeof html !== 'string') return;
          var wrap = document.createElement('div');
          wrap.innerHTML = html.trim();
          var cartDrawerSection = wrap.firstElementChild;
          if (!cartDrawerSection) return;
          var selectors = ['.cart_footer', '.cc_cart_items', '.recommendations', '.cc_cart_drawer_title'];
          for (var i = 0; i < selectors.length; i++) {
            var sel = selectors[i];
            var newEl = cartDrawerSection.querySelector(sel);
            var oldEl = document.querySelector(sel);
            if (newEl && oldEl) {
              oldEl.parentNode.insertBefore(newEl, oldEl);
              oldEl.remove();
            }
          }
          if (typeof window.progress_bar === 'function') {
            window.progress_bar(cartDrawerSection);
          }
        })
        .catch(function () {});
    }
  
    function lpOpenCartDrawer() {
      var drawer = document.querySelector('.drawer');
      lpRefreshCartDrawerContent().then(function () {
        document.body.setAttribute('data-cart-open', 'true');
        if (drawer) {
          drawer.classList.add('active');
          document.body.classList.add('fixed');
        }
        try {
          document.dispatchEvent(new CustomEvent('cart:open'));
        } catch (e) {}
        if (typeof window.getCartProducts === 'function') {
          window.getCartProducts();
        }
      });
    }
  
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.lp-cfg__select-box')) {
        qsa('.lp-cfg__dropdown--open').forEach(function (d) { d.classList.remove('lp-cfg__dropdown--open'); });
        qsa('.lp-cfg__select-arrow--open').forEach(function (a) { a.classList.remove('lp-cfg__select-arrow--open'); });
      }
    });
  
    // ── Tab 2: Category tabs — on change show products for that collection ─
    section.addEventListener('click', function (e) {
      var catBtn = e.target.closest('.lp-cfg__tab2-cat');
      if (catBtn) {
        e.preventDefault();
        var handle = catBtn.dataset.handle;
        var title = catBtn.dataset.title || '';
        qsa('.lp-cfg__tab2-cat').forEach(function (b) { b.classList.remove('lp-cfg__tab2-cat--active'); });
        catBtn.classList.add('lp-cfg__tab2-cat--active');
        qsa('.lp-cfg__tab2-grid-pane').forEach(function (p) {
          p.classList.toggle('lp-cfg__tab2-grid-pane--active', p.dataset.handle === handle);
        });
        qsa('.lp-cfg__tab2-grid-title-pane').forEach(function (p) {
          p.classList.toggle('lp-cfg__tab2-grid-title-pane--active', p.dataset.handle === handle);
        });
        return;
      }
      var atcBtn = e.target.closest('.lp-cfg__tab2-card-atc');
      if (atcBtn) {
        e.preventDefault();
        var variantId = atcBtn.dataset.variantId;
        if (!variantId) return;
        var btnText = atcBtn.textContent;
        atcBtn.disabled = true;
        atcBtn.textContent = 'Adding…';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        })
          .then(function (res) { return res.json(); })
          .then(function (data) {
            if (data.status && data.status !== 200 && data.message) {
              atcBtn.textContent = btnText;
              atcBtn.disabled = false;
              alert(data.message);
              return;
            }
            atcBtn.textContent = 'Added!';
            setTimeout(function () { atcBtn.textContent = btnText; atcBtn.disabled = false; }, 1500);
            lpOpenCartDrawer();
          })
          .catch(function () {
            atcBtn.textContent = btnText;
            atcBtn.disabled = false;
          });
      }
    });
  
    // ── Init ─────────────────────────────────────────────────────
    function lpInit() {
      // Click on engrave header or chain row toggles option (checkbox has its own onclick)
      if (!window._lpRowClickBound) {
        window._lpRowClickBound = true;
        document.addEventListener('click', function (e) {
          var engHeader = e.target && e.target.closest && e.target.closest('.lp-cfg__engrave-header');
          if (engHeader) {
            var isP2Header = !!engHeader.closest('#lp-engrave-wrap-2');
            var checkboxId = isP2Header ? '#lp-engrave-checkbox-2' : '#lp-engrave-checkbox';
            if (!e.target.closest(checkboxId)) {
              lpToggleEngraving(isP2Header ? 2 : 1);
              return;
            }
          }
          var chainRow = e.target && e.target.closest && e.target.closest('.lp-cfg__chain');
          if (chainRow && !e.target.closest('#lp-chain-checkbox')) {
            lpToggleChain();
          }
        });
      }
  
      var opts = qs('#lp-engrave-options');
      if (opts) opts.classList.toggle('lp-cfg__engrave-input--visible', lpEngraveOn);
      var engCb = qs('#lp-engrave-checkbox');
      if (engCb) {
        engCb.textContent = lpEngraveOn ? '✓' : '';
        engCb.style.background = lpEngraveOn ? '#0a0a0a' : '#fff';
        engCb.classList.toggle('lp-cfg__engrave-checkbox--unchecked', !lpEngraveOn);
      }
      var engWrap = qs('#lp-engrave-wrap');
      if (engWrap) engWrap.classList.toggle('lp-cfg__engrave--selected', lpEngraveOn);
  
      // Sync engrave Location and single/both input visibility on init
      qsa('.lp-cfg__engrave-btn[data-value]').forEach(function (btn) {
        var val = btn.getAttribute('data-value');
        var isLoc = btn.id && btn.id.indexOf('lp-engrave-loc') !== -1;
        if (isLoc) btn.classList.toggle('lp-cfg__engrave-btn--selected', val === lpEngraveLocation);
      });
      var rowSingle = qs('#lp-engrave-row-single');
      var rowBoth = qs('#lp-engrave-row-both');
      var labelEl = qs('#lp-engrave-text-label');
      if (lpEngraveLocation === 'Both') {
        if (rowSingle) rowSingle.style.display = 'none';
        if (rowBoth) rowBoth.style.display = 'flex';
      } else {
        if (rowSingle) rowSingle.style.display = 'flex';
        if (rowBoth) rowBoth.style.display = 'none';
        if (labelEl) labelEl.textContent = lpEngraveLocation === 'Front' ? 'Front' : lpEngraveLocation === 'Back' ? 'Back' : 'ENGRAVING TEXT';
      }
  
      // Engraving text character counters (single + front + back when Both)
      var maxChars = parseInt(qs('#lp-engrave-text') && qs('#lp-engrave-text').getAttribute('maxlength'), 10) || 16;
      function bindEngraveCount(inputId, countId) {
        var inp = qs(inputId);
        var cnt = qs(countId);
        if (!inp || !cnt) return;
        function upd() {
          var len = (inp.value || '').length;
          cnt.textContent = len + '/' + maxChars;
        }
        inp.addEventListener('input', upd);
        inp.addEventListener('change', upd);
        upd();
      }
      bindEngraveCount('#lp-engrave-text', '#lp-engrave-char-count');
      bindEngraveCount('#lp-engrave-text-front', '#lp-engrave-char-count-front');
      bindEngraveCount('#lp-engrave-text-back', '#lp-engrave-char-count-back');
  
      // Pendant 2 engraving char counters + state sync
      bindEngraveCount('#lp-engrave-text-2', '#lp-engrave-char-count-2');
      bindEngraveCount('#lp-engrave-text-front-2', '#lp-engrave-char-count-front-2');
      bindEngraveCount('#lp-engrave-text-back-2', '#lp-engrave-char-count-back-2');
  
      var opts2 = qs('#lp-engrave-options-2');
      if (opts2) opts2.classList.toggle('lp-cfg__engrave-input--visible', lpEngraveOn2);
      var engCb2 = qs('#lp-engrave-checkbox-2');
      if (engCb2) {
        engCb2.textContent = lpEngraveOn2 ? '✓' : '';
        engCb2.style.background = lpEngraveOn2 ? '#0a0a0a' : '#fff';
        engCb2.classList.toggle('lp-cfg__engrave-checkbox--unchecked', !lpEngraveOn2);
      }
      var engWrap2 = qs('#lp-engrave-wrap-2');
      if (engWrap2) engWrap2.classList.toggle('lp-cfg__engrave--selected', lpEngraveOn2);
      qsa('.lp-cfg__engrave-btn[data-value]').forEach(function (btn) {
        if (!btn.id || btn.id.indexOf('lp-engrave-loc') === -1) return;
        var isP2Btn = btn.id.slice(-2) === '-2';
        if (!isP2Btn) return;
        btn.classList.toggle('lp-cfg__engrave-btn--selected', btn.getAttribute('data-value') === lpEngraveLocation2);
      });
      var rowSingle2 = qs('#lp-engrave-row-single-2');
      var rowBoth2   = qs('#lp-engrave-row-both-2');
      var labelEl2   = qs('#lp-engrave-text-label-2');
      if (lpEngraveLocation2 === 'Both') {
        if (rowSingle2) rowSingle2.style.display = 'none';
        if (rowBoth2) rowBoth2.style.display = 'flex';
      } else {
        if (rowSingle2) rowSingle2.style.display = 'flex';
        if (rowBoth2) rowBoth2.style.display = 'none';
        if (labelEl2) labelEl2.textContent = lpEngraveLocation2 === 'Front' ? 'Front' : lpEngraveLocation2 === 'Back' ? 'Back' : 'ENGRAVING TEXT';
      }
  
      lpUpdateChainPriceDisplay();
      lpUpdateEngravePriceDisplay();
      lpRefreshChainVariantSelector();
  
      lpRefreshNumberDropdown(1);
      lpRefreshNumberDropdown(2);
  
      var prod1 = lpProductForMetal('gold');
      var mainImg = qs('#lp-main-img');
      if (mainImg && prod1 && prod1.featured_image) {
        var src = lpImageSrc(prod1.featured_image);
        if (src) mainImg.src = src;
      }
      lpRefreshThumbs();
  
      lpUpdateCartBtn();
  
      // Position selectors-wrap under the selected qty option (1 Pendant or 2 Pendants)
      var q1 = qs('#lp-qty1');
      var q2 = qs('#lp-qty2');
      var wrap = qs('#lp-selectors-wrap');
      var qtyParent = q1 && q1.parentNode;
      if (wrap && qtyParent) {
        if (lpQtySelected === 1) {
          qtyParent.insertBefore(wrap, q2);
        } else {
          qtyParent.appendChild(wrap);
        }
      }
    }
  
    document.addEventListener('DOMContentLoaded', lpInit);
  
    // If DOM already loaded (e.g. script is deferred)
    if (document.readyState !== 'loading') lpInit();
  
    // Add event listeners to clear errors on user interaction
    function lpClearEngraveError(pendantNum) {
      var errorId = pendantNum === 2 ? 'lp-engrave-error-2' : 'lp-engrave-error-1';
      var errorEl = qs('#' + errorId);
      if (errorEl) {
        errorEl.textContent = '';
        errorEl.classList.remove('lp-cfg__error-message--visible');
      }
      // Remove highlight from engraving inputs
      var inputs = document.querySelectorAll('.lp-cfg__engrave-text-input' + (pendantNum === 2 ? '[id*="-2"]' : ':not([id*="-2"])'));
      inputs.forEach(function(inp) {
        inp.classList.remove('lp-error');
      });
    }
  
    function lpClearNumberError(pendantNum) {
      var errorId = pendantNum === 2 ? 'lp-number-error-2' : 'lp-number-error-1';
      var errorEl = qs('#' + errorId);
      if (errorEl) {
        errorEl.textContent = '';
        errorEl.classList.remove('lp-cfg__error-message--visible');
      }
      // Remove highlight from number trigger
      var selectorId = pendantNum === 2 ? '#lp-number-selector-2' : '#lp-number-selector-1';
      var trigger = qs(selectorId + ' .lp-cfg__select-trigger');
      if (trigger) {
        trigger.classList.remove('lp-error');
      }
    }
  
    // Add listeners after init
    function lpAddErrorClearListeners() {
      // For engraving inputs
      var engraveInputs = document.querySelectorAll('.lp-cfg__engrave-text-input');
      engraveInputs.forEach(function(input) {
        input.addEventListener('input', function() {
          var pendantNum = input.id.includes('-2') ? 2 : 1;
          lpClearEngraveError(pendantNum);
        });
      });
  
      // For number selectors - clear on click (when user starts selecting)
      var numberSelectors = document.querySelectorAll('[id^="lp-number-selector-"] .lp-cfg__select-trigger');
      numberSelectors.forEach(function(trigger) {
        trigger.addEventListener('click', function() {
          var selector = trigger.closest('[id^="lp-number-selector-"]');
          var pendantNum = selector.id.includes('-2') ? 2 : 1;
          lpClearNumberError(pendantNum);
        });
      });
    }
  
    // Call after init
    document.addEventListener('DOMContentLoaded', lpAddErrorClearListeners);
    if (document.readyState !== 'loading') lpAddErrorClearListeners();
  
  })();
  